import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeLines: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="code-lines"><path d="M2.75 4.75H13.2M17.75 4.75H21.25M2.75 12H8.25M12.75 12H21.25M2.75 19.25H10.25M14.75 19.25H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
};

export default IconCodeLines;
